<template>
    <svg
        :data-component-name="$options.name"
        class="o-ico"
        :class="class"
        aria-hidden="true" role="img"
        v-if="$root.spriteURL"
    >
        <use :xlink:href="$root.spriteURL+'#'+icon"></use>
    </svg>
</template>
<script>
    export default {
        name: 'svgIco',
        props: {
        	icon:{
        		type: String,
        		default: '',
            },
            class: {
                type: String,
                default: '',
            }
        },
    }
</script>